import React, { Component } from 'react';
import _ from 'lodash';
import ToDoCreate from './ToDoCreate';
import ToDoList from './ToDoList';
import {Container,Row,Col} from 'reactstrap';
//Sample data
const todos = [
    {
      task: 'Approve BCM.',
      isCompleted: false
    },
    {
      task: 'Prepare scorecard.',
      isCompleted: false
    }
];


class ToDo extends Component  {

  createTask(task) {
    this.state.todos.push({
      task,
      isCompleted: false
    });
    this.setState({ todos: this.state.todos });
  }

  deleteTask(taskToDelete) {
    _.remove(this.state.todos, todo => todo.task === taskToDelete);
    this.setState({ todos: this.state.todos });
  }

  saveTask(oldTask, newTask) {
    const foundTodo = _.find(this.state.todos, todo => todo.task === oldTask);
    foundTodo.task = newTask;
    this.setState({ todos: this.state.todos });
  }

  toggleTask(task) {
    const foundTodo = _.find(this.state.todos, todo => todo.task === task);
    foundTodo.isCompleted = !foundTodo.isCompleted;
    this.setState({ todos: this.state.todos });
  }

  constructor(props) {
    super(props);

    this.state = {
      todos: todos
    }
  }

  render() {
    return (
 
     <Container>
        <Row>
            <Col >
               <div className="td-list-con">
                   <ToDoCreate
    todos={ this.state.todos }
    createTask={ this.createTask.bind(this)}/>
      
   <ToDoList
    todos={ this.state.todos }
    saveTask={ this.saveTask.bind(this) }
    deleteTask={ this.deleteTask.bind(this) }
    toggleTask={ this.toggleTask.bind(this) }/>
</div>
</Col>
</Row>
</Container>
           
      )
   }
}
export default ToDo;
